import React from "react";
import { connect } from 'react-redux';
import ReactTable from "react-table";
import Datetime from "react-datetime";


// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Close from "@material-ui/icons/Close";
import SaveAlt from "@material-ui/icons/SaveAlt";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from '@material-ui/core/TextField';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Tooltip from "@material-ui/core/Tooltip";

import Today from "@material-ui/icons/Today";


import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import { fetchJobCardsRequest } from "../../../actions/jobCard";
import { formatStatus, prepareJobCardReports } from "../../../utils/helpers";
import { fetchMetersRequest } from "../../../actions/stockController";


const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
};

class ViewMeters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openReportDialog: false,
    }
  }

  componentWillMount() {
    this.props.dispatch(fetchMetersRequest());
  }

  attachActions(meters) {
    return meters.map((prop, key) => {
      return Object.assign(prop,
        {
          assignmentStatus: prop.jobCardAssigned ? "Assigned" : "Unassigned",
          actions: (
            // we've added some custom button actions
            <div className="actions-right">
              {/* use this button to add a edit kind of action */}
              {
                prop.jobCardAssigned &&
                <Tooltip
                id="tooltip-top"
                title="View Assigned Job Card"
                placement="top"
              >
                <Button
                  justIcon
                  round
                  simple
                  color="warning"
                  className="edit"
                  onClick={() => this.props.history.push(`job/view/${prop.jobCardAssigned.jobCardNumber}`)}
                >
                  <Dvr />
                </Button>
              </Tooltip>
              }
              
              {" "}
              {/* use this button to remove the data row */}
              <Tooltip
                id="tooltip-top"
                title="Delete Job Card"
                placement="top"
              >
                <Button
                  justIcon
                  round
                  simple
                  color="danger"
                  className="remove"
                >
                  <Close />
                </Button>
              </Tooltip>
              {" "}
            </div>
          )
        });
    })
  }

  render() {
    const { classes } = this.props;

    let meters = this.props.stockControllerData.meters || [];
    meters = this.attachActions(meters);
    return (
      <GridContainer>
        <GridItem xs={12}>

          <Card>
            <CardHeader color="info" icon>
              <CardIcon color="info">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>List of Availabe Meters</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={meters}
                filterable
                columns={[
                  {
                    Header: "Created At",
                    accessor: "createdAt"
                  },
                  {
                    Header: "Meter Type",
                    accessor: "meterTyper"
                  },
                  {
                    Header: "Condition",
                    accessor: "condition"
                  },
                  {
                    Header: "Payment Type",
                    accessor: "meterPaymentType"
                  },
                  {
                    Header: "Dial Type",
                    accessor: "meterDialType"
                  },
                  {
                    Header: "Meter Number",
                    accessor: "meterNumber"
                  },
                  {
                    Header: "Status",
                    accessor: "assignmentStatus"
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                  }
                ]}
                defaultPageSize={20}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight"
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(styles)(
  connect(state => ({
    stockControllerData: state.stockControllerState,
  }))(ViewMeters)
);
